import CouponsSpecialStoreDetails from './CouponsSpecialStoreDetails'

export default CouponsSpecialStoreDetails